// avoiding package root import to avoid circular dependency
// eslint-disable-next-line monorepo/no-internal-import
import {Locale} from '@aboutyou/config/src/locale';
import {getStaticRoutesByLocale_UNSAFE} from './getStaticRoutesByLocale';
import {DeprecatedRouteKeys, RouteKey} from './routeKeys';

export function getStaticRoute_UNSAFE(
  key: Exclude<RouteKey, DeprecatedRouteKeys>,
  locale: Locale,
) {
  // eslint-disable-next-line no-restricted-syntax
  const config = getStaticRoutesByLocale_UNSAFE(locale);
  if (!config) {
    throw new Error(
      `Unknown locale value provided.${locale} not found in the list of Locales`,
    );
  }
  return `/${config[key]}`;
}
